import { Box, Button, Stack } from "@mui/material";
import Popup from "../../../common/Modal";
import styles from "./styles";
import { getNoSlotsMsg } from "../../../common/NoSlotsChecker";

export const CreateRegistrationErrorPopup = ({
  errors,
  pageText,
  handleClose: closeCallback,
  toggleSteps,
}: {
  errors?: string[];
  pageText: any;
  handleClose: () => void;
  toggleSteps: Function;
}) => {
  const noSlotsMessage = errors?.[0] === getNoSlotsMsg(pageText);

  const handleClose = () => {
    closeCallback();
    if (noSlotsMessage) {
      toggleSteps("examDetails", 1);
    }
  };

  return (
    <Popup open={!!errors} handleClose={handleClose}>
      <Box sx={styles.modalBody}>
        {errors?.map((error, index) => (
          <Box key={index}>{error}</Box>
        ))}
      </Box>
      <Stack direction="row" justifyContent="center" gap={2}>
        <Button variant="outlined" onClick={handleClose}>
          {pageText?.buttonsMetadata?.okButtonText}
        </Button>
      </Stack>
    </Popup>
  );
};
